import React from 'react';
import './Navigation.css'

const Navigation = () => {
    return(
        <div className='flex justify-end'>
            <p className='f4 dim ma3 pa4 washed-red pointer'>Sign Out</p>
        </div>
    );
}

export default Navigation;
